import { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import styled from "styled-components";
import MLPLogo from "../imgs/my-life-plan.png";

const LoadingAnimation = ({
  loading,
  onComplete,
}: {
  loading?: boolean;
  onComplete: any;
}) => {
  const growDotControls = useAnimation();
  const bounceKeyframes = {
    x: [0, 77, 154, 231, 308, 385],
    y: [0, -40, 0, -30, 0, -20, 0, -10, 0, -5, 0],
  };

  useEffect(() => {
    if (!loading) {
      growDotControls
        .start({
          x: "-50%",
          y: "-50%",
          width: 160,
          height: 160,
          backgroundColor: "#243aff",
          transition: {
            duration: 1,
            ease: "easeInOut",
          },
        })
        .then(() => {
          growDotControls.start({
            width: 80,
            height: 80,
            transition: {
              duration: 0.6,
              ease: "easeOut",
            },
          });
          setTimeout(() => onComplete(), 2000);
        });
    }

    return () => {};
  }, [loading, growDotControls, onComplete]);

  return (
    <Wrapper className="hide-on-med-and-down">
      <h1 className="logo-text">
        <img
          className={`animate__animated ${loading ? "" : "animate__fadeOut"}`}
          src={MLPLogo}
          alt="my life plan"
        />
        <span>.</span>
      </h1>
      {loading ? (
        <motion.div
          className="dot"
          animate={bounceKeyframes}
          transition={{
            duration: 2.5,
            ease: "easeInOut",
            times: [0, 0.2, 0.4, 0.6, 0.8, 1],
            repeat: Infinity,
            repeatDelay: 2,
            repeatType: "loop",
          }}
        />
      ) : (
        // <motion.div
        //   className="grow-dot"
        //   initial={{
        //     width: 12,
        //     height: 12,
        //     backgroundColor: "#000",
        //     borderRadius: "50%",
        //     position: "absolute",
        //     top: "50%",
        //     left: "calc(50% + 192px)",
        //     x: 0,
        //     y: 0,
        //   }}
        //   animate={growDotControls}
        // />
        <></>
      )}
    </Wrapper>
  );
};

export default LoadingAnimation;

const Wrapper = styled.div`
  height: 100vh;
  width: 100vw;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .dot {
    width: 12px;
    height: 12px;
    background: #000;
    border-radius: 50%;
    position: absolute;
    top: calc(50% - 36px);
    left: calc(50% - 192px);
    box-shadow: -3px 8px 11px 0px rgba(0,0,0,0.75);
  }

  img {
    width: 570px;
    margin-top: -105px;
  }

  span {
    color: transparent;
  }

  @media only screen and (max-width: 650px) {
    margin-left: 50px;
    img {
      width: 570px;
      margin-top: -50px;
    }
  }
`;
